import useUpdateOrderMutation from "../mutations/orders/useUpdateOrderMutation";

const useUpdateOrdersStatus = () => {
  const { mutateAsync } = useUpdateOrderMutation();
  return (status: string, ids: number[]) =>
    Promise.all(
      ids.map((id) =>
        mutateAsync({
          orderId: id,
          status,
        })
      )
    );
};

export default useUpdateOrdersStatus;
